export default "__VITE_ASSET__COEY19UJ__"